import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { Reveal } from '@/components/generals/reveal'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <Reveal className='site-shell'>
            <Header />

            <main>
                {children}
            </main>

            <Footer />
        </Reveal>
    )
}
